import { getRoleVerificationRequestStateStore } from '@front-app/modules/user/hooks/useRoleVerificationRequestedState';
import { computed } from '@vue/composition-api';
import { CurrentUserStore } from './User';

export const roleVerificationRequestStateStore = getRoleVerificationRequestStateStore(computed(() => CurrentUserStore.currentUser.value.id));
